import { render, staticRenderFns } from "./topheader.vue?vue&type=template&id=fb2b5f88&scoped=true&"
import script from "./topheader.vue?vue&type=script&lang=js&"
export * from "./topheader.vue?vue&type=script&lang=js&"
import style0 from "./topheader.vue?vue&type=style&index=0&id=fb2b5f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b5f88",
  null
  
)

export default component.exports